module.exports = __webpack_public_path__ + "img/BIT_white08.a8b5abd2.jpg";